import React from 'react'
import { Result } from 'antd'

export const Unauthorized = () => <Result subTitle="Unauthorized. Log in to access this page" />
